<template>
    <button @click="$emit('click', $event)" class="message">
        <i class="fas fa-info-circle"></i>
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: "qw-error"
}
</script>

<style lang="scss" scoped>
.message {
    width: 100%;
    margin: 0;
    padding: 7px 0px;
    font-family: $lato;
    font-weight: normal;
    font-size: 13px;
    text-align: left;
    color: $red;
    background-color: transparent;
    @include removeBootstrapOutline;
    i {
        margin: 0px 5px 0px 0px;
    }
}
</style>